import { TimelineItemProps } from 'components/Timeline/__types';
import { createEscolaRoute, escolaEditRoute } from 'library/Routes';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { RootState } from 'store';
import {
  getProgramaInfo,
  getTipoDocumentacaoCoop,
  setCurrentTab,
} from 'store/modules/EscolasActions';
import languageValues from 'utils/LanguageUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { EscolaEditTabs, TipoPrograma } from '../__enum';
import { ESCOLA_ETAPAS_PARAMS_URL } from 'models/escola';
import { SchoolEditParams } from '../__types';

export default function useEscolaSteps() {
  const { id } = useParams<SchoolEditParams>();
  const location = useLocation();
  const currentTab = useSelector((state: RootState) => state.escolas.currentTab);
  const history = useHistory();
  const dispatch = useDispatch();

  const changeTab = useCallback(
    (idChangeTab: string, tab: EscolaEditTabs) => {
      const isCadastro = location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.CADASTRO);
      if (isCadastro) {
        history.push(createEscolaRoute.getURLWithParams(idChangeTab, tab));
        dispatch(setCurrentTab(tab));
      } else {
        history.push(escolaEditRoute.getURLWithParams(idChangeTab, tab));
        dispatch(setCurrentTab(tab));
      }
    },
    [dispatch, history, location.pathname]
  );

  const getTimelineItemIndex = useCallback(
    (props: TimelineItemProps[]) => {
      return props.findIndex((i) => i.id === currentTab);
    },
    [currentTab]
  );

  const handleNext = useCallback(() => {
    changeTab(id, EscolaEditTabs.ProgramasEducacionais);
  }, [changeTab, id]);

  const handleBack = useCallback(() => {
    changeTab(id, EscolaEditTabs.Informacoes);
    dispatch(getProgramaInfo(id));
  }, [changeTab, dispatch, id]);

  const handleProgramaInfoFetch = useCallback(
    (tipoPrograma: TipoPrograma) => {
      dispatch(
        getProgramaInfo(
          id,
          tipoPrograma,
          () => { },
          () => {
            SnackbarUtils.error(
              languageValues.toasts.error.educationalProgramsSearchError
            );
          }
        )
      );
    },
    [dispatch, id]
  );

  const handleTipoDocumentoFetch = useCallback(() => {
    dispatch(getTipoDocumentacaoCoop());
  }, [dispatch]);

  return {
    changeTab,
    handleNext,
    handleBack,
    getTimelineItemIndex,
    handleTipoDocumentoFetch,
    handleProgramaInfoFetch,
  };
}
